var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Simple training loop, that could apply to any arbitrary neural network,
 * so nothing in this file really has anything to do with GPT specifically.
 *
 * See the following repositories for reference:
 * - https://github.com/karpathy/ng-video-lecture
 * - https://github.com/karpathy/nanoGPT
 * - https://github.com/karpathy/minGPT
 */
import * as tf from '@tensorflow/tfjs';
export function Trainer(args) {
    var _this = this;
    var model = args.model, dataset = args.dataset, callbacks = args.callbacks, params = args.params;
    var evalIterations = params.evalIterations, learningRate = params.learningRate, evalInterval = params.evalInterval, maxIters = params.maxIters, batchSize = params.batchSize, blockSize = params.blockSize;
    var train = function () { return __awaiter(_this, void 0, void 0, function () {
        var optimizer, estimateLoss, _loop_1, iter, state_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    optimizer = model.optimizer({ learningRate: learningRate });
                    estimateLoss = function () { return tf.tidy(function () {
                        var result = {};
                        for (var _i = 0, _a = ['train', 'test']; _i < _a.length; _i++) {
                            var split = _a[_i];
                            var losses = tf.zeros([1]);
                            for (var iter = 0; iter < evalIterations; iter++) {
                                var _b = dataset.getBatch({ split: split, batchSize: batchSize, blockSize: blockSize }), x = _b.x, y = _b.y;
                                var loss = model.loss(x, y);
                                losses = losses.add(loss);
                            }
                            result[split] = losses.div(evalIterations);
                        }
                        return result;
                    }); };
                    _loop_1 = function (iter) {
                        var _e, test, train_1, testLoss, _f, trainLoss, _g, _h, x, y;
                        return __generator(this, function (_j) {
                            switch (_j.label) {
                                case 0:
                                    if (!(iter === 0 || (iter + 1) % evalInterval === 0 || iter === maxIters - 1)) return [3 /*break*/, 3];
                                    _e = estimateLoss(), test = _e.test, train_1 = _e.train;
                                    _f = parseFloat;
                                    return [4 /*yield*/, test.data()];
                                case 1:
                                    testLoss = _f.apply(void 0, [(_a = (_j.sent())[0]) === null || _a === void 0 ? void 0 : _a.toFixed(4)]);
                                    _g = parseFloat;
                                    return [4 /*yield*/, train_1.data()];
                                case 2:
                                    trainLoss = _g.apply(void 0, [(_b = (_j.sent())[0]) === null || _b === void 0 ? void 0 : _b.toFixed(4)]);
                                    callbacks.onEval({ step: iter + 1, trainLoss: trainLoss, testLoss: testLoss });
                                    test === null || test === void 0 ? void 0 : test.dispose();
                                    train_1 === null || train_1 === void 0 ? void 0 : train_1.dispose();
                                    _j.label = 3;
                                case 3:
                                    _h = dataset.getBatch({ split: 'train', batchSize: batchSize, blockSize: blockSize }), x = _h.x, y = _h.y;
                                    // Evaluate the loss
                                    optimizer.minimize(function () {
                                        var loss = model.loss(x, y);
                                        return loss.squeeze();
                                    });
                                    x.dispose();
                                    y.dispose();
                                    if ((_c = callbacks === null || callbacks === void 0 ? void 0 : callbacks.isStopRequested) === null || _c === void 0 ? void 0 : _c.call(callbacks))
                                        return [2 /*return*/, "break"];
                                    // Unblock the main thread (allow the UI to be re-rendered)
                                    // if the training is running in the browser
                                    return [4 /*yield*/, tf.nextFrame()];
                                case 4:
                                    // Unblock the main thread (allow the UI to be re-rendered)
                                    // if the training is running in the browser
                                    _j.sent();
                                    return [2 /*return*/];
                            }
                        });
                    };
                    iter = 0;
                    _d.label = 1;
                case 1:
                    if (!(iter < maxIters)) return [3 /*break*/, 4];
                    return [5 /*yield**/, _loop_1(iter)];
                case 2:
                    state_1 = _d.sent();
                    if (state_1 === "break")
                        return [3 /*break*/, 4];
                    _d.label = 3;
                case 3:
                    iter++;
                    return [3 /*break*/, 1];
                case 4:
                    optimizer.dispose();
                    return [2 /*return*/];
            }
        });
    }); };
    return { train: train };
}
